'use client'
import React, { ReactElement, useState } from 'react'
import HeaderCopyright from '@/components/headers/HeaderCopyright'
import Divider from '@/components/Divider'
import Navigation from '@/components/navigation/Navigation'

const NotYetContests = (): ReactElement => {
    const [leftOpen, setLeftOpen] = useState(false)

    return (
        <React.Fragment>
            <HeaderCopyright />
            <div className="main-container">
                <Navigation />
                <Divider />
                <h1 className={'white centered-row'}>NOT YET IMPLEMENTED</h1>
                <div className="centered-text gray">
                    For example sweepstakes for NFT holders.
                    <br />
                </div>
            </div>
        </React.Fragment>
    )
}

export default NotYetContests
